import { Link } from 'react-router-dom';

const CITIES = [
  {
    name: 'Port St. Lucie',
    county: 'St. Lucie County',
    desc: 'The largest city in the Treasure Coast, Port St. Lucie is our home base. We serve all neighborhoods including Tradition, St. Lucie West, Torino, Vinings, and PGA Village.',
    img: 'https://public.readdy.ai/ai/img_res/15a82d2f68525c446737a2c7a8ab8c09.jpg',
    services: ['Residential', 'Commercial', 'Deep Clean', 'Move In/Out'],
    population: '~230,000',
  },
  {
    name: 'Stuart',
    county: 'Martin County',
    desc: 'The Sailfish Capital of the World, Stuart is the county seat of Martin County. We serve downtown Stuart, Poppleton Creek, and all surrounding communities.',
    img: 'https://readdy.ai/api/search-image?query=charming%20downtown%20stuart%20florida%20waterfront%20marina%20sailboats%20palm%20trees%20sunny%20day%20colorful%20buildings%20tropical%20florida%20small%20city&width=600&height=380&seq=city2&orientation=landscape',
    services: ['Residential', 'Commercial', 'Retail Cleaning'],
    population: '~17,000',
  },
  {
    name: 'Fort Pierce',
    county: 'St. Lucie County',
    desc: 'A vibrant coastal city with a rich cultural heritage, Fort Pierce is home to many of our commercial and residential clients along the Indian River Lagoon.',
    img: 'https://readdy.ai/api/search-image?query=fort%20pierce%20florida%20waterfront%20downtown%20harbor%20palm%20trees%20bright%20sunny%20day%20tropical%20coastal%20city%20colorful%20buildings&width=600&height=380&seq=city3&orientation=landscape',
    services: ['Residential', 'Commercial', 'Post-Construction'],
    population: '~45,000',
  },
  {
    name: 'Jensen Beach',
    county: 'Martin County',
    desc: 'Known as the "Pineapple Capital," Jensen Beach is a charming coastal community where we provide top-tier cleaning services for homes and businesses alike.',
    img: 'https://readdy.ai/api/search-image?query=jensen%20beach%20florida%20coastal%20town%20beach%20community%20palm%20trees%20ocean%20breeze%20beautiful%20homes%20tropical%20sunny%20day%20relaxed%20atmosphere&width=600&height=380&seq=city4&orientation=landscape',
    services: ['Residential', 'Vacation Rentals', 'Commercial'],
    population: '~14,000',
  },
  {
    name: 'Palm City',
    county: 'Martin County',
    desc: 'A thriving community in Martin County, Palm City features many upscale residential neighborhoods and growing commercial areas where A&S Cleaning is a trusted name.',
    img: 'https://readdy.ai/api/search-image?query=palm%20city%20florida%20upscale%20residential%20community%20luxury%20homes%20palm%20trees%20green%20neighborhood%20sunny%20day%20beautiful%20manicured%20lawns%20south%20florida&width=600&height=380&seq=city5&orientation=landscape',
    services: ['Residential', 'Deep Clean', 'Move In/Out'],
    population: '~25,000',
  },
  {
    name: 'Hobe Sound',
    county: 'Martin County',
    desc: 'A picturesque unincorporated community bordering Jonathan Dickinson State Park, Hobe Sound is home to many families and luxury estates that count on A&S Cleaning.',
    img: 'https://readdy.ai/api/search-image?query=hobe%20sound%20florida%20scenic%20coastal%20community%20nature%20preserve%20luxury%20homes%20green%20trees%20peaceful%20tropical%20neighborhood%20sunny&width=600&height=380&seq=city6&orientation=landscape',
    services: ['Residential', 'Estate Cleaning', 'Deep Clean'],
    population: '~14,000',
  },
  {
    name: 'Tradition',
    county: 'St. Lucie County',
    desc: 'One of Florida\'s newest master-planned communities, Tradition is a fast-growing hub in Port St. Lucie where we frequently service new homes and businesses.',
    img: 'https://readdy.ai/api/search-image?query=tradition%20port%20st%20lucie%20florida%20master%20planned%20community%20new%20modern%20homes%20clean%20streets%20palm%20trees%20bright%20sunny%20day%20vibrant%20new%20development&width=600&height=380&seq=city7&orientation=landscape',
    services: ['Residential', 'Commercial', 'New Construction'],
    population: '~15,000',
  },
  {
    name: 'Port Salerno',
    county: 'Martin County',
    desc: 'A historic waterfront fishing community in Martin County, Port Salerno features a growing mix of residential neighborhoods and waterfront businesses we proudly serve.',
    img: 'https://readdy.ai/api/search-image?query=port%20salerno%20florida%20fishing%20village%20waterfront%20marina%20boats%20community%20dock%20palm%20trees%20sunny%20coastal%20tropical%20scene&width=600&height=380&seq=city8&orientation=landscape',
    services: ['Residential', 'Commercial', 'Marine Facilities'],
    population: '~10,000',
  },
  {
    name: 'St. Lucie West',
    county: 'St. Lucie County',
    desc: 'A popular planned community west of I-95 in Port St. Lucie, St. Lucie West is home to shopping centers, offices, and residential communities we service regularly.',
    img: 'https://readdy.ai/api/search-image?query=st%20lucie%20west%20florida%20suburban%20community%20shopping%20center%20modern%20commercial%20district%20palm%20trees%20clean%20streets%20sunny%20south%20florida%20suburb&width=600&height=380&seq=city9&orientation=landscape',
    services: ['Residential', 'Commercial', 'Office Cleaning'],
    population: '~24,000',
  },
];

const SITE_URL = import.meta.env.VITE_SITE_URL || '';

export default function LocationsPage() {
  const locationsSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Service Areas | A&S Prestige Cleaning Service',
    url: `${SITE_URL}/locations`,
    description: 'A&S Prestige Cleaning Service serves all cities in Port St. Lucie, St. Lucie County, and Martin County, FL including Stuart, Fort Pierce, Jensen Beach, Palm City, Hobe Sound and more.',
    mainEntity: {
      '@type': 'CleaningService',
      name: 'A&S Prestige Cleaning Service',
      url: SITE_URL,
      telephone: '+15618461326',
      email: 'asprestigecleaningservice62@gmail.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Port St. Lucie',
        addressRegion: 'FL',
        addressCountry: 'US',
      },
      areaServed: CITIES.map((city) => ({
        '@type': 'City',
        name: city.name,
        containedInPlace: {
          '@type': 'AdministrativeArea',
          name: city.county,
        },
      })),
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Service Areas', item: `${SITE_URL}/locations` },
      ],
    },
  };

  return (
    <main>
      <title>Cleaning Service Areas | Port St. Lucie, Stuart, Fort Pierce &amp; More | A&S</title>
      <meta name="description" content="A&S Cleaning Service covers all of Port St. Lucie, St. Lucie County &amp; Martin County, FL — including Stuart, Fort Pierce, Jensen Beach, Palm City, Hobe Sound, Tradition and more." />
      <meta name="keywords" content="cleaning service areas florida, port st lucie cleaning company, martin county cleaning service, stuart cleaning company, fort pierce cleaning service" />
      <link rel="canonical" href={`${SITE_URL}/locations`} />
      <meta property="og:title" content="Cleaning Service Areas | A&S Cleaning Service FL" />
      <meta property="og:description" content="Proudly serving all cities in Port St. Lucie, St. Lucie County, and Martin County, FL. See if we cover your area." />
      <meta property="og:url" content={`${SITE_URL}/locations`} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(locationsSchema) }}
      />

      {/* Hero */}
      <section className="relative pt-32 pb-20">
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20view%20treasure%20coast%20florida%20port%20st%20lucie%20martin%20county%20map%20region%20sunny%20beautiful%20neighborhoods%20waterways%20lush%20green%20tropical%20aerial%20panoramic%20view&width=1440&height=500&seq=lochero&orientation=landscape"
          alt="Port St. Lucie and Martin County service area"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60" />
        <div className="relative z-10 text-center px-6 max-w-3xl mx-auto">
          <span className="inline-block bg-emerald-600/90 text-white text-xs font-bold tracking-widest uppercase px-5 py-2 rounded-full mb-5">
            Service Area
          </span>
          <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-5 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Areas We Serve
          </h1>
          <p className="text-gray-200 text-lg max-w-xl mx-auto">
            A&amp;S Cleaning Service is proud to serve homeowners and businesses throughout Port St. Lucie (St. Lucie County) and Martin County, Florida.
          </p>
        </div>
      </section>

      {/* Service Area Banner */}
      <section className="bg-emerald-600 py-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-emerald-500 rounded-xl">
              <i className="ri-map-pin-2-line text-white text-2xl" />
            </div>
            <div>
              <p className="text-white font-bold text-lg">Serving All of St. Lucie &amp; Martin County</p>
              <p className="text-emerald-100 text-sm">10+ cities and communities covered</p>
            </div>
          </div>
          <Link to="/contact" className="bg-white text-emerald-700 hover:bg-emerald-50 font-bold px-8 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer">
            Check Your Area
          </Link>
        </div>
      </section>

      {/* Cities Grid */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-14">
            <span className="text-emerald-600 font-bold text-sm tracking-widest uppercase">Cities We Cover</span>
            <h2 className="text-4xl font-extrabold text-gray-900 mt-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Your City Is On Our List
            </h2>
            <p className="text-gray-500 mt-3 max-w-xl mx-auto">From Port St. Lucie to the heart of Martin County — wherever you are, A&amp;S Cleaning Service is nearby.</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {CITIES.map((city) => (
              <div key={city.name} className="border border-gray-100 rounded-2xl overflow-hidden hover:border-emerald-200 transition-colors group">
                <div className="h-52 overflow-hidden">
                  <img
                    src={city.img}
                    alt={`${city.name}, ${city.county}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <h3 className="text-xl font-bold text-gray-900">{city.name}</h3>
                      <div className="flex items-center gap-1 mt-0.5">
                        <i className="ri-map-pin-line text-emerald-600 text-xs" />
                        <span className="text-gray-400 text-xs">{city.county}</span>
                      </div>
                    </div>
                    <span className="bg-emerald-50 text-emerald-700 text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap">
                      Pop. {city.population}
                    </span>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.desc}</p>
                  <div className="flex flex-wrap gap-2">
                    {city.services.map((s) => (
                      <span key={s} className="bg-gray-100 text-gray-600 text-xs font-medium px-3 py-1 rounded-full">{s}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Map Embed */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-extrabold text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>Our Service Area</h2>
            <p className="text-gray-500 mt-3">Port St. Lucie &amp; Martin County, Florida</p>
          </div>
          <div className="rounded-2xl overflow-hidden h-96 w-full">
            <iframe
              title="A&S Cleaning Service Area - Port St. Lucie and Martin County FL"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d230467.78637753!2d-80.3808!3d27.2737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88defe66eb9c2dbb%3A0x49de1bc73e84bf25!2sPort%20St.%20Lucie%2C%20FL!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-emerald-600 py-16">
        <div className="max-w-3xl mx-auto text-center px-6">
          <h2 className="text-3xl font-extrabold text-white mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Don&apos;t See Your City?
          </h2>
          <p className="text-emerald-100 mb-8">Give us a call or send us a message — we may still be able to accommodate your location in the Treasure Coast area.</p>
          <Link to="/contact" className="bg-white text-emerald-700 hover:bg-emerald-50 font-bold px-10 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer inline-block">
            Contact Us
          </Link>
        </div>
      </section>
    </main>
  );
}
